<template>
  <v-row justify="center">
    <v-dialog
      v-model="displaySelf"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Блокировка пользователя</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                :sm="12"
              >
                <WBDLaborerListFilterComponent
                  :remote-list="getCurrentUser"
                  :remote-selected-option="''"
                  @onLaborerSelectorFilterChange="onLaborerSelectorFilterChange"
                />
              </v-col>
              <v-col
                cols="12"
                :sm="12"
              >
                <v-autocomplete
                  v-model="model.level"
                  :items="blockLevelList"
                  item-text="title"
                  item-value="id"
                  label="Уровень блокировки"
                />
              </v-col>
              <v-col
                cols="12"
                :sm="6"
              >
                <v-select
                  v-model="model.blockType"
                  :items="getBlockTypeList"
                  label="Тип блокировки"
                  :item-text="'title'"
                  :item-value="'id'"
                  return-object
                  required
                />
              </v-col>
              <v-col
                cols="12"
                :sm="6"
              >
                <v-text-field
                  v-model="model.duration"
                  label="Длительность в днях"
                  required
                  :disabled="!isTemporaryBlock"
                  type="number"
                  :error="isTemporaryBlock && !hasValidDuration"
                />
              </v-col>
              <v-col
                cols="12"
                :sm="12"
              >
                <v-textarea
                  v-model="model.description"
                  label="Причина блокировки"
                  required
                  hint="минимум 5 букв"
                  :error="!model.description"
                  persistent-hint
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="warning"
            text
            @click="$emit('onCloseBlackListFormModal')"
          >
            Отменить
          </v-btn>
          <v-btn
            :disabled="!canSave"
            :color="isTemporaryBlock ? `success`:'error'"
            text
            @click="save"
          >
            {{ `Блокировать ${isTemporaryBlock ? '':'на всегда'}` }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import WBDLaborerListFilterComponent from '@/components/common/filter/laborer-filter'
import BlackListMixin from '@/mixins/black-list-mixin'
import {
  BLACK_LIST_LEVEL_ORGANIZATION,
  BLACK_LIST_LEVEL_OFFICE,
  BLACK_LIST_LEVEL_VACANCY,
  BLACK_LIST_LEVEL_SYSTEM,
  BLACK_LIST_LEVEL_LEGAL_ENTITY_LEVEL,
} from '@/components/common/filter/black-list-level'

export const BLOCK_TYPE_TEMPORARY = 'temporary'
export const BLOCK_TYPE_PERMANENT = 'permanent'
export default {
  name: 'BlackListCreateModal',
  components: { WBDLaborerListFilterComponent },
  mixins: [BlackListMixin],
  props: {
    displaySelf: {
      type: Boolean,
      default: false,
    },
    saveCallback: {
      type: Function,
    },
    filterSet: {
      type: Object,
      default: () => (
        {
          level: null,
          model: null,
          user: null,
          relay: null,
        }
      )
    }
  },
  data: () => ({
    model: {
      fullName: null,
      id: null,
      duration: null,
      level: null,
      user: null,
      description: null,
      blockType: { id: BLOCK_TYPE_TEMPORARY, title: `Временный` },
    }
  }),
  computed: {
    canSave () {
      const { user, description } = this.model
      return !!user && ((this.isTemporaryBlock && this.hasValidDuration) || !this.isTemporaryBlock) &&
          description && description.trim().length >= 5
    },
    isTemporaryBlock () {
      const { blockType } = this.model
      return blockType && blockType.id === BLOCK_TYPE_TEMPORARY
    },
    hasValidDuration () {
      const { duration } = this.model
      return duration && duration.trim().length > 0 && parseInt(duration, 10) > 0
    },
    getCurrentUser () {
      if (this.filterSet.user) {
        return [this.filterSet.user]
      }

      return []
    },
    getModelTitle () {
      if (this.model.level === BLACK_LIST_LEVEL_SYSTEM) {
        return 'СЕРВИС'
      }
      return this.filterSet.model.title
    },
    getBlockTypeList () {
      return [
        { id: BLOCK_TYPE_TEMPORARY, title: `Временный` },
        { id: BLOCK_TYPE_PERMANENT, title: `На всегда` },
      ]
    },
    blockLevelList () {
      return [
        { id: this.filterSet.level, title: `${this.getModelTitle}` },
        // { id: 'organization', title: `Организация` },
      ]
    },
  },
  watch: {
    model: {
      handler (val) {},
      deep: true,
    },
  },
  created () {
    this.model.level = this.filterSet.level
    this.model.id = this.filterSet.model.id
    if (this.filterSet.user) {
      this.model.user = this.filterSet.user.id
    }
    if (this.model.level === BLACK_LIST_LEVEL_SYSTEM) {
      this.model.id = null
      this.model.id = null
    }
  },
  methods: {
    onLaborerSelectorFilterChange (data) {
      this.model.user = data
    },
    async save () {
      try {
        const filter = {
          level: this.model.level,
          office: null,
          vacancy: null,
          organization: null,
          legalEntity: null,
          description: this.model.description,
          user: this.model.user,
          expiredAt: null,
          relay: this.filterSet.relay,
          duration: this.model.duration ? parseInt(this.model.duration, 10) : undefined,
        }

        if (this.model.level === BLACK_LIST_LEVEL_LEGAL_ENTITY_LEVEL) {
          filter.legalEntity = this.model.id
        }
        if (this.model.level === BLACK_LIST_LEVEL_ORGANIZATION) {
          filter.organization = this.model.id
        }

        if (this.model.level === BLACK_LIST_LEVEL_OFFICE) {
          filter.office = this.model.id
        }

        if (this.model.level === BLACK_LIST_LEVEL_VACANCY) {
          filter.vacancy = this.model.id
        }

        await this.proceedCreate(filter, this.saveCallback)
        this.$emit('onUserBlackListed')
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>
